import { StormImpactModel } from "@/types";
import {
  AbstractModelSelectionPill,
  GenericModel,
} from "./AbstractModelSelectionPill";

interface StormImpactModelSelectionPillProps {
  models?: StormImpactModel[];
  selectedModel?: StormImpactModel;
  onModelSelect?: (model: StormImpactModel) => void;
  isLoading?: boolean;
}

const adaptStormImpactModel = (model: StormImpactModel): GenericModel => ({
  modelName: model.model_name,
  modelSlug: model.model_slug,
  modelDescription: model.model_description || model.model_summary || undefined,
});

export function StormImpactModelSelectionPill({
  models = [],
  selectedModel,
  onModelSelect,
  isLoading = false,
}: StormImpactModelSelectionPillProps) {
  if (isLoading) {
    return (
      <div className="px-2 py-1 rounded-md text-xs font-medium flex items-center bg-secondary text-secondary-foreground opacity-60">
        <span>Loading...</span>
      </div>
    );
  }

  const adaptedModels = models.map(adaptStormImpactModel);
  const adaptedSelectedModel = selectedModel
    ? adaptStormImpactModel(selectedModel)
    : undefined;

  const handleModelSelect = (adaptedModel: GenericModel) => {
    const originalModel = models.find(
      (model) => model.model_slug === adaptedModel.modelSlug,
    );
    if (originalModel && onModelSelect) {
      onModelSelect(originalModel);
    }
  };

  return (
    <AbstractModelSelectionPill
      models={adaptedModels}
      selectedModel={adaptedSelectedModel}
      onModelSelect={handleModelSelect}
      labelPrefix="Model:"
      dropdownTitle="StormImpact Model"
    />
  );
}
